// Blog Post Image Are Here
import blogUserImg from './assets/img/blog-imgs/blog-userpic1.svg';
import blogThumbnail from './assets/img/blog-imgs/blog-image1.png'

// Post Details images Are Here
import postThumbnail from './assets/img/blog-details-imgs/bd-postimg.png';
import roundedCircle from './assets/img/blog-details-imgs/bd-userimg.png'

// Clips post images Are here 
import authIcon from './assets/img/blog-imgs/blog-userpic1.svg';
import vidoethubnail from './assets/img/blog-imgs/blog-image2.png';

// Clips Details Image Are Here
import clipsUser from "./assets/img/blog-imgs/blog-userpic1.svg";
import clipsBlog from './assets/img/blog-imgs/blog-image2.png'

// Fundrasers Images Are Here
import frImage from './assets/img/fundraiser-imgs/fr-img1.png';

// Event Cover Image are here
import eventCoverImage from './assets/img/event-details-imgs/event-coverimg.png'; 
import eventAuthorImage from './assets/img/event-details-imgs/description/ed-descriptionimg1.png';
import eventSecAuthorImage from './assets/img/event-details-imgs/description/ed-descriptionimg2.png'
import eventPostThumbnailImage from './assets/img/feed-imgs/center/homepost/user-post2.png';
import eventMainDescUserImageOne from './assets/img/event-details-imgs/description/ed-descriptionimg1.png';
import eventMainDescUserImageTwo from './assets/img/event-details-imgs/description/ed-descriptionimg2.png';
import eventMainDescUserImageThree from './assets/img/event-details-imgs/description/ed-descriptionimg3.png';
import eventMainDescUserImageFour from './assets/img/event-details-imgs/description/ed-descriptionimg4.png';
import eventMainDescUserImageFive from './assets/img/event-details-imgs/description/ed-descriptionimg5.png';

//Clip Details Image Are Here
import smilingThree from './assets/img/clips-imgs/clip-smallimg3.png';
import smilingTwo from './assets/img/clips-imgs/clip-smallimg2.png';
import smilingOne from './assets/img/clips-imgs/clip-smallimg1.png';
import testVideoOne from './assets/media/test1.mp4'
import testVideoTwo from './assets/media/test2.mp4'
import testVideoThree from './assets/media/test3.mp4'


// Hole Blog Datas
export const getBlogDatas = async (id) =>{
    return [
        {
            id: 0,
            dateOfBlogPost : "NOV 25, 2020",
            blogTitle : "In pulvinar libero eu puru vehicula, et Maruf...",
            blogTags : [  "Erotic", "Blonde","Travel"  ],
            authorImage: roundedCircle,
            name: "Maruf Mobin",
            postThumbnail: postThumbnail,
            thumbnailDescription : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Maruf",
            blogFistPara: "In at tincidunt ipsum. Donec fermentum dictum luctus. Sed vehicula faucibus felis, porttitor sollicitudin risus auctor eu. Duis placerat, massa non euismod porttitor, mauris odio porta nisl, sit amet pretium quam nibh quis turpis. Cras non faucibus nisl, at mollis lectus. Vestibulum vitae vestibulum ex. Phasellus nec finibus leo, ut finibus ex. Nulla nec ex nisi. Mauris ut lectus non ipsum feugiat tincidunt. Phasellus sit amet maximus dolor. Mauris ac nisi a sapien iaculis tristique. Donec posuere iaculis diam, sit amet ullamcorper urna porta id. Aliquam scelerisque tincidunt lobortis. In hendrerit leo et felis pharetra, ut interdum justo fringilla Maruf",
            blogSecondPara : "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Maecenas egestas cursus libero eu mattis. Etiam aliquam, urna ac interdum luctus, elit libero molestie nunc, eget facilisis metus eros et nibh. Phasellus vulputate aliquam ante, id hendrerit quam laoreet congue. In eu elit vehicula, scelerisque ex efficitur, bibendum augue. Nulla facilisi. maruf",
            bulletePoints: [
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. maruf",
                "Donec a mauris ut lectus eleifend laoreet eu ac felis.",
                "Pellentesque ornare eros at dolor porta cursus vel a odio.",
                "Nunc ultrices dui nec metus fringilla, id posuere nisi tempor.",
                "Nam molestie magna et imperdiet iaculis."
            ],
            heartRate: 259,
            massages: 134,
            sharignPeople: 25
        },
        {
            id: 2,
            dateOfBlogPost : "January 10, 2022",
            blogTitle : "In pulvinar libero eu puru vehicula, et ManojBhai...",
            blogTags : [  "Erotic", "Blonde","Travel","tour"  ],
            authorImage: roundedCircle,
            name: "Manoj Khumar",
            postThumbnail: postThumbnail,
            thumbnailDescription : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. ManojBhai",
            blogFistPara: "In at tincidunt ipsum. Donec fermentum dictum luctus. Sed vehicula faucibus felis, porttitor sollicitudin risus auctor eu. Duis placerat, massa non euismod porttitor, mauris odio porta nisl, sit amet pretium quam nibh quis turpis. Cras non faucibus nisl, at mollis lectus. Vestibulum vitae vestibulum ex. Phasellus nec finibus leo, ut finibus ex. Nulla nec ex nisi. Mauris ut lectus non ipsum feugiat tincidunt. Phasellus sit amet maximus dolor. Mauris ac nisi a sapien iaculis tristique. Donec posuere iaculis diam, sit amet ullamcorper urna porta id. Aliquam scelerisque tincidunt lobortis. In hendrerit leo et felis pharetra, ut interdum justo fringilla ManojBhai",
            blogSecondPara : "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Maecenas egestas cursus libero eu mattis. Etiam aliquam, urna ac interdum luctus, elit libero molestie nunc, eget facilisis metus eros et nibh. Phasellus vulputate aliquam ante, id hendrerit quam laoreet congue. In eu elit vehicula, scelerisque ex efficitur, bibendum augue. Nulla facilisi. ManojBhai",
            bulletePoints: [
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ManojBhai",
                "Donec a mauris ut lectus eleifend laoreet eu ac felis.",
                "Pellentesque ornare eros at dolor porta cursus vel a odio.",
                "Nunc ultrices dui nec metus fringilla, id posuere nisi tempor.",
                "Nam molestie magna et imperdiet iaculis."
            ],
            heartRate: 500,
            massages: 134,
            sharignPeople: 30
        },
        {
            id: 0,
            dateOfBlogPost : "Sep 05, 2010",
            blogTitle : "In pulvinar libero eu puru vehicula, et Shafin Bhai...",
            blogTags : [  "Erotic", "Blonde","Travel"  ],
            authorImage: roundedCircle,
            name: "Shafin Samsu",
            postThumbnail: postThumbnail,
            thumbnailDescription : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Shafin",
            blogFistPara: "In at tincidunt ipsum. Donec fermentum dictum luctus. Sed vehicula faucibus felis, porttitor sollicitudin risus auctor eu. Duis placerat, massa non euismod porttitor, mauris odio porta nisl, sit amet pretium quam nibh quis turpis. Cras non faucibus nisl, at mollis lectus. Vestibulum vitae vestibulum ex. Phasellus nec finibus leo, ut finibus ex. Nulla nec ex nisi. Mauris ut lectus non ipsum feugiat tincidunt. Phasellus sit amet maximus dolor. Mauris ac nisi a sapien iaculis tristique. Donec posuere iaculis diam, sit amet ullamcorper urna porta id. Aliquam scelerisque tincidunt lobortis. In hendrerit leo et felis pharetra, ut interdum justo fringilla Shafin",
            blogSecondPara : "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Maecenas egestas cursus libero eu mattis. Etiam aliquam, urna ac interdum luctus, elit libero molestie nunc, eget facilisis metus eros et nibh. Phasellus vulputate aliquam ante, id hendrerit quam laoreet congue. In eu elit vehicula, scelerisque ex efficitur, bibendum augue. Nulla facilisi. Shafin",
            bulletePoints: [
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Shafin",
                "Donec a mauris ut lectus eleifend laoreet eu ac felis.",
                "Pellentesque ornare eros at dolor porta cursus vel a odio.",
                "Nunc ultrices dui nec metus fringilla, id posuere nisi tempor.",
                "Nam molestie magna et imperdiet iaculis."
            ],
            heartRate: 259,
            massages: 134,
            sharignPeople: 25
        },
        {
            id: 0,
            dateOfBlogPost : "NOV 25, 2020",
            blogTitle : "In pulvinar libero eu puru vehicula, et luctus Rafi bhai...",
            blogTags : [  "Erotic", "Blonde","Travel", "enjoy"  ],
            authorImage: roundedCircle,
            name: "Nrj Rafi",
            postThumbnail: postThumbnail,
            thumbnailDescription : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Rafi",
            blogFistPara: "In at tincidunt ipsum. Donec fermentum dictum luctus. Sed vehicula faucibus felis, porttitor sollicitudin risus auctor eu. Duis placerat, massa non euismod porttitor, mauris odio porta nisl, sit amet pretium quam nibh quis turpis. Cras non faucibus nisl, at mollis lectus. Vestibulum vitae vestibulum ex. Phasellus nec finibus leo, ut finibus ex. Nulla nec ex nisi. Mauris ut lectus non ipsum feugiat tincidunt. Phasellus sit amet maximus dolor. Mauris ac nisi a sapien iaculis tristique. Donec posuere iaculis diam, sit amet ullamcorper urna porta id. Aliquam scelerisque tincidunt lobortis. In hendrerit leo et felis pharetra, ut interdum justo fringilla Rafi",
            blogSecondPara : "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Maecenas egestas cursus libero eu mattis. Etiam aliquam, urna ac interdum luctus, elit libero molestie nunc, eget facilisis metus eros et nibh. Phasellus vulputate aliquam ante, id hendrerit quam laoreet congue. In eu elit vehicula, scelerisque ex efficitur, bibendum augue. Nulla facilisi. Rafi",
            bulletePoints: [
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Rafi",
                "Donec a mauris ut lectus eleifend laoreet eu ac felis.",
                "Pellentesque ornare eros at dolor porta cursus vel a odio.",
                "Nunc ultrices dui nec metus fringilla, id posuere nisi tempor.",
                "Nam molestie magna et imperdiet iaculis."
            ],
            heartRate: 199,
            massages: 134,
            sharignPeople: 10
        },
    ]
}

export const blogPosts = async () =>{
    return [
        {
            id: 1,
            blogThumbnail: blogThumbnail,
            blogDate: "May 25, 2020",
            authorImage: blogUserImg,
            authorName: "Maruf Mobin",
            blogDesc: "In pulvinar libero eu puru vehicula, et..."
        },
        {
            id: 2,
            blogThumbnail: blogThumbnail,
            blogDate: "jan 25, 2020",
            authorImage: blogUserImg,
            authorName: "Haider Mawla",
            blogDesc: "In pulvinar libero eu puru vehicula, et..."
        },
        {
            id: 3,
            blogThumbnail: blogThumbnail,
            blogDate: "Nov 25, 2020",
            authorImage: blogUserImg,
            authorName: "Abbas Alamder",
            blogDesc: "In pulvinar libero eu puru vehicula, et..."
        },
        {
            id:4,
            blogThumbnail: blogThumbnail,
            blogDate: "Dec 25, 2020",
            authorImage: blogUserImg,
            authorName: "zulzana",
            blogDesc: "In pulvinar libero eu puru vehicula, et..."
        },
    ]
}

// Clips All Data Here
export const clipsData = async() =>{
    return [
        {
            videoThumbanil : vidoethubnail,
            videoHoure: "10:6",
            shortDesc: "In pulvinar libero eu puru vehicula, et... maruf",
            authorIcon: authIcon,
            authName: "Maruf Mobin",
            rating: 3.3,
            ratingPeople: 189,
            clipPrice: 30.00
        },
        {
            videoThumbanil : vidoethubnail,
            videoHoure: "11:26",
            shortDesc: "In pulvinar libero eu puru vehicula, et... ManojBhai",
            authorIcon: authIcon,
            authName: "Manoj bhai",
            rating: 7.3,
            ratingPeople: 350,
            clipPrice: 89.00
        },
        {
            videoThumbanil : vidoethubnail,
            videoHoure: "09:26",
            shortDesc: "In pulvinar libero eu puru vehicula, et... Rafi bhai",
            authorIcon: authIcon,
            authName: "Rafi bhai",
            rating: 8.9,
            ratingPeople: 18,
            clipPrice: 22.00
        },
        {
            videoThumbanil : vidoethubnail,
            videoHoure: "07:26",
            shortDesc: "In pulvinar libero eu puru vehicula, et.. safin Bhai",
            authorIcon: authIcon,
            authName: "Shafin bhai",
            rating: 4.3,
            ratingPeople: 254,
            clipPrice: 59.00
        },
    ]
}

// Clips Single Data Are Here
export const clipsSingleData = async(id) =>{
    return [
        {
            id: 0,
            tags: [
                "Sensation",
            ],
            clipTitle: "Halloween Bunny Bound and Maruf (hd Mp4)",
            avarageRating: 3.2,
            ratingPeople: 254,
            authorIcon: clipsUser,
            authName: "Shafin bhai",
            lengthOfVideo : "11 Minutes",
            videoFormat: "Mp4",
            videoSize: "420MB",
            resolution: "1920x1080",
            startingRate: "200.00",
            clipsThumbnail : clipsBlog,
            videoRelatedInfo : [
                 smilingOne,
                 smilingTwo,
               
            ],
            realVideoUrl :[
                testVideoOne,
                      testVideoTwo,
            ]
        },
        {
            id: 1,
            tags: [
                "Sensation",
                "Music",
                "dance"
            ],
            clipTitle: "Halloween Bunny Bound and Mobin (hd Vrm)",
            avarageRating: 2.2,
            ratingPeople: 190,
            authorIcon: clipsUser,
            authName: "Mobin Hussain",
            lengthOfVideo : "9 Minutes",
            videoFormat: "Vrm",
            videoSize: "320MB",
            resolution: "1920x1080",
            startingRate: "77.00",
            clipsThumbnail : clipsBlog,
            videoRelatedInfo : [
                
               
                      smilingOne,
                   smilingTwo,
                      smilingThree,


            ],
            realVideoUrl :[
                testVideoOne,
                      testVideoTwo,
                     testVideoThree
            ]
        },
        {
            id: 2,
            tags: [
                "Play",
                "Music",
                "summing"
            ],
            clipTitle: "Halloween Bunny Bound and Manoj BHai (hd Vfrm)",
            avarageRating: 4.2,
            ratingPeople: 254,
            authorIcon: clipsUser,
            authName: "Manoj Kumar",
            lengthOfVideo : "81 Minutes",
            videoFormat: "Vfrm",
            videoSize: "500MB",
            resolution: "1920x1080",
            startingRate: "500.00",
            clipsThumbnail : clipsBlog,
            videoRelatedInfo : [
                
               
                        smilingOne,
                smilingTwo,
                       smilingThree,
            ],
            realVideoUrl :[
                testVideoOne,
                      testVideoTwo,
                     testVideoThree
            ]
        },
        {
            id: 3,
            tags: [
                "Rain",
                "Mud"
            ],
            clipTitle: "Halloween Bunny Bound and Robin Hood (hd Mp3)",
            avarageRating: 1.2,
            ratingPeople: 20,
            authorIcon: clipsUser,
            authName: "Robin Hood",
            lengthOfVideo : "11 Minutes",
            videoFormat: "Mp3",
            videoSize: "20MB",
            resolution: "1920x1080",
            startingRate: "99.00",
            clipsThumbnail : clipsBlog, 
            videoRelatedInfo : [
                
               smilingOne,
                   smilingTwo,
              smilingThree,

            ],
            realVideoUrl :[
                testVideoOne,
                      testVideoTwo,
                     testVideoThree
            ]
        },
        {
            id: 4,
            tags: [
                "Solow"
            ],
            clipTitle: "Halloween Bunny Bound and Shafin Bhia (hd vvv)",
            avarageRating: 4.2,
            ratingPeople: 254,
            authorIcon: clipsUser,
            authName: "Shafin bhai",
            lengthOfVideo : "111 Minutes",
            videoFormat: "VVV",
            videoSize: "19MB",
            resolution: "1920x1080",
            startingRate: "20.00",
            clipsThumbnail : clipsBlog,
            videoRelatedInfo : [
                     smilingOne,
                      smilingTwo,
                   smilingThree,
                    
            ],
            realVideoUrl :[
                testVideoOne,
                      testVideoTwo,
                     testVideoThree
            ]
        },
       
    ]
}


// Fundraisers Page Data Here 
export const fundraiserPostDatas = async() =>{
    return [
        {
            thumnailImage: frImage,
            fundersTitle : 'Maruf Mobin for Child',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '2,356',
            targetStatus: '61%',
            leftDay: '15'
        },
        {
            thumnailImage: frImage,
            fundersTitle : 'Manoj Kumar for Development Sociaty',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '8,356',
            targetStatus: '97%',
            leftDay: '1'
        },
        {
            thumnailImage: frImage,
            fundersTitle : 'Shovna for Development Education .',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '1,356',
            targetStatus: '20%',
            leftDay: '25'
        },
        {
            thumnailImage: frImage,
            fundersTitle : 'Raj Bharman For Temple Renew perpuss',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '7,356',
            targetStatus: '20%',
            leftDay: '30'
        },
        {
            thumnailImage: frImage,
            fundersTitle : 'MuthoLaxmi for Ediction Remover',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '356',
            targetStatus: '75%',
            leftDay: '5'
        },
        {
            thumnailImage: frImage,
            fundersTitle : 'Md Rafi for Road Stablish',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '356',
            targetStatus: '75%',
            leftDay: '5'
        },
        {
            thumnailImage: frImage,
            fundersTitle : 'Md Rony Roy Stady',
            fundersDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
            risersAmount: '1.4k',
            targetStatus: '80%',
            leftDay: '20'
        },
    ]
}

// Fundraisers Single Data Are here 
export const fundraiserPostDetails  = async(id) =>{
    return [
        {
            id: 0,
            tags: [
                "Funding",
                "save people",
                "For human"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi Stereo System shafin",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 12,
            backers: 254,
            authorIcon: clipsUser,
            authName: "Shafin bhai",
            total: 50,
            needed: 100,
            clipsThumbnail : clipsBlog,
        },
        {
            id: 1,
            tags: [
                "Honesty",
                "Fund",
                "Charity"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi Stereo Mobin",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 15,
            backers: 190,
            authorIcon: clipsUser,
            authName: "Mobin Hussain",
            total: 750,
            needed: 1000,
            clipsThumbnail : clipsBlog,
        },
        {
            id: 2,
            tags: [
                "funds",
                "Charity",
                "honesty"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi  Manoj BHai ",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 9,
            backers: 254,
            authorIcon: clipsUser,
            authName: "Manoj Kumar",
            total: 33.33,
            needed: 100,
            clipsThumbnail : clipsBlog,
        },
        {
            id: 3,
            tags: [
                "Honesty",
                "Social Wok",
                "Charity"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi Stereo System Robin Hood",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 1.2,

            backers: 20,
            authorIcon: clipsUser,
            authName: "Robin Hood",
            total: 25,
            needed:100,
            clipsThumbnail : clipsBlog,
        },
        {
            id: 4,
            tags: [
                "for The People",
                "Honesty",
                "Charity"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi Stereo Shafin Bhia",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 4.2,
            backers: 254,
            authorIcon: clipsUser,
            authName: "Shafin bhai",
            total: 7.5,
            needed: 10,
            clipsThumbnail : clipsBlog,
        },
        {
            id: 5,
            tags: [
                "huminity"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi Stereo Shafin Bhia",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 4.2,
            backers: 254,
            authorIcon: clipsUser,
            authName: "Shafin bhai",
            total: 5,
            needed: 10,
            clipsThumbnail : clipsBlog,
        },
        {
            id: 5,
            tags: [
                "Charity"
            ],
            clipTitle: "Dum Audio: Beautiful, Soulful Hi-Fi Stereo Shafin Bhia",
            fundingRejon: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam ac volutpat mi. Donec condimentum mauris metus, quis ultrices sapien tempor sit am Ut a dapibus quam.',
            dayLeft: 12,
            backers: 254,
            authorIcon: clipsUser,
            authName: "Rony Bhai",
            total: 20,
            needed: 20,
            clipsThumbnail : clipsBlog,
        },
       
    ]
}

// Event Page every Event post data here

export const showAllEventsData = async() =>{
    return [
        {
            eventThumbnail: '',
            eventData: 'Mon, Nov 20 at 1:00 pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '1.3k',
            goingPeople: '25',
        },
        {
            eventThumbnail: '',
            eventData: 'Sat, Des 29 at 2:00 pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '2.3k',
            goingPeople: '30',
        },
        {
            eventThumbnail: '',
            eventData: 'Thu, May 10 at 1:00 pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '1.9k',
            goingPeople: '10',
        },
        {
            eventThumbnail: '',
            eventData: 'Sun, Nov 29 at 2:00 pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '5.8k',
            goingPeople: '50',
        },
        {
            eventThumbnail: '',
            eventData: 'Fri, Oct 29 at 01:00pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '7.9k',
            goingPeople: '1.2',
        },
        {
            eventThumbnail: '',
            eventData: 'Fri, May 11 at 11:00pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '1.9k',
            goingPeople: '90',
        },
        {
            eventThumbnail: '',
            eventData: 'Wes, Jan 01 at 11:0 pm',
            eventTitle: 'In pulvinar libero eu puru vehicula, et ',
            interestedPeople: '5.55',
            goingPeople: '50',
        }
    ]
}

// Single Event Post Data are here
export const singleEventPostDetails  = async() =>{
    return [
        {
            id: 0,
            eventImageUrl : eventCoverImage,
            eventData: "Mon, Nov 29 on 11:00 pm",
            eventStatus: "Online Event",
            eventType: "Monthly",
            eventTitle: "In pulvinar libero eu puru vehicula,et luctus...",
            eventDesc: "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Maruf",
            eventCreater: [
                { 
                   eventby :  "Maruf Mobin",
                   response : "204 people responded",
                   Privacy : "Public, Anyone can join",              
                   interested : 20,
                   going : 5
                }
            ],
            eventRelatedPosts : [
                {
                    id: 0,
                    postAutherName: "Maruf Mobin ",
                    postTime: "1 Houre",
                    postAuthorImage: eventAuthorImage,
                    postThumbnail: eventPostThumbnailImage,
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Maruf",
                    postReaction: [
                        {
                            heart:300,
                            massage: 90,
                            plus: 56,
                            share: 5
                        }
                    ]
                },
                {
                    id: 1,
                    postAutherName: "Sumaiya Yasmin ",
                    postTime: "1 Houre",
                    postAuthorImage: eventSecAuthorImage,
                    postThumbnail: eventPostThumbnailImage,
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Maruf",
                    postReaction: [
                        {
                            heart: 150,
                            massage: 80,
                            plus: 30,
                            share: 50
                        }
                    ]
                }
            ],
            eventMainDesc:[ 
                {
                    decs: '„Gucci“ – visame pasaulyje dominuojantis prekės ženklas, bet dar negirdėta jo šeimos istorija, kurioje slypi melas, išdavystė, kerštas ir žmogžudystė. Buvusi Maurizio Gucci žmona, Patrizia Reggiani, buvo apkaltinta savo vyro žmogžudystės užsaky mu po to, kai buvo palikta dėl Maruf',
                    eventMainDescImages : [ eventMainDescUserImageOne, eventMainDescUserImageTwo,eventMainDescUserImageThree,eventMainDescUserImageFour,eventMainDescUserImageFive ]
                },
            ]
            
        },
        {
            id: 1,
            eventImageUrl : eventCoverImage,
            eventData: "Sun, Nov 29 on 11:00 pm",
            eventStatus: "Online Event",
            eventType: "Weckly",
            eventTitle: "In pulvinar libero eu puru vehicula,et luctus...",
            eventDesc: "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Manoj Bhai",
            eventCreater: [
                { 
                   eventby :  "Manoj Bhai",
                   response : "105 people responded",
                   Privacy : "Public, Anyone can join",              
                   interested : 111,
                   going : 34
                }
            ],
            eventRelatedPosts : [
                {
                    id: 0,
                    postAutherName: "Manoj bhai",
                    postTime: "5h ago",
                    postAuthorImage: eventSecAuthorImage,
                    postThumbnail: eventPostThumbnailImage,
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Manoj bhai",
                    postReaction: [
                        {
                            heart: 787,
                            massage: 952,
                            plus: 602,
                            share: 61
                        }
                    ]
                },
                {
                    id: 1,
                    postAutherName: "Jankar Mahbub",
                    postTime: "2h ago",
                    postAuthorImage: eventAuthorImage,
                    postThumbnail: eventPostThumbnailImage,
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos Jankar Mahbub.",
                    postReaction: [
                        {
                            heart: 85,
                            massage: 15,
                            plus: 94,
                            share: 250
                        }
                    ]
                },
                {
                    id: 2,
                    postAutherName: "Anil Kumblay",
                    postTime: "5h ago",
                    postAuthorImage: "",
                    postThumbnail: "",
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.",
                    postReaction: [
                        {
                            heart: 259,
                            massage: 259,
                            plus: 62,
                            share: 25
                        }
                    ]
                },
            ],
            eventMainDesc:[ 
                {
                    decs: '„Gucci“ – visame pasaulyje dominuojantis prekės ženklas, bet dar negirdėta jo šeimos istorija, kurioje slypi melas, išdavystė, kerštas ir žmogžudystė. Buvusi Maurizio Gucci žmona, Patrizia Reggiani, buvo apkaltinta savo vyro žmogžudystės užsaky mu po to, kai buvo palikta dėl Manoj bhai',
                    eventMainDescImages : [ eventMainDescUserImageOne, eventMainDescUserImageTwo,eventMainDescUserImageThree ]
                },
            ]
        },
        {
            id: 2,
            eventImageUrl : eventCoverImage,
            eventData: "Fri, Nov 29 on 11:00 pm",
            eventStatus: "Online Event",
            eventType: "daily",
            eventTitle: "In pulvinar libero eu puru vehicula,et luctus... Shafin bhai",
            eventDesc: "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi Shafin bhai.",
            eventCreater: [
                { 
                   eventby :  "Shafin bhai.",
                   response : "55 people responded",
                   Privacy : "Public, Anyone can join",              
                   interested : 75,
                   going : 28
                }
            ],
            eventRelatedPosts : [
                {
                    id: 0,
                    postAutherName: "Raj Sir",
                    postTime: "5h ago",
                    postAuthorImage: "",
                    postThumbnail: "",
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. raj sir",
                    postReaction: [
                        {
                            heart: 500,
                            massage: 500,
                            plus: 500,
                            share: 250
                        }
                    ]
                },
                {
                    id: 1,
                    postAutherName: "Shamim",
                    postTime: "5h ago",
                    postAuthorImage: "",
                    postThumbnail: "",
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Shamim sir",
                    postReaction: [
                        {
                            heart: 500,
                            massage: 500,
                            plus: 500,
                            share: 250
                        }
                    ]
                },
                {
                    id: 2,
                    postAutherName: "Raj Sir",
                    postTime: "5h ago",
                    postAuthorImage: "",
                    postThumbnail: "",
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. raj sir",
                    postReaction: [
                        {
                            heart: 500,
                            massage: 500,
                            plus: 500,
                            share: 250
                        }
                    ]
                }
            ],
            eventMainDesc:[ 
                {
                    decs: '„Gucci“ – visame pasaulyje dominuojantis prekės ženklas, bet dar negirdėta jo šeimos istorija, kurioje slypi melas, išdavystė, kerštas ir žmogžudystė. Buvusi Maurizio Gucci žmona, Patrizia Reggiani, buvo apkaltinta savo vyro žmogžudystės užsaky mu po to, kai buvo palikta dė l shafin bhai',
                    eventMainDescImages : [ eventMainDescUserImageOne, eventMainDescUserImageTwo,eventMainDescUserImageThree,eventMainDescUserImageFour]
                },
            ]
        },
        {
            id: 3,
            eventImageUrl : eventCoverImage,
            eventData: "Mon, Nov 29 on 11:00 pm",
            eventStatus: "Online Event",
            eventType: "Monthly",
            eventTitle: "In pulvinar libero eu puru vehicula,et luctus...",
            eventDesc: "Morbi venenatis et nisi finibus egestas. Morbi arcu metus, dictum sit amet consectetur ac, iaculis ac nisi. Shovna Mam",
            eventCreater: [
                { 
                   eventby :  "Lily Luis",
                   response : "25 people responded",
                   Privacy : "Public, Anyone can join",              
                   interested : 68,
                   going : 18
                }
            ],
            eventRelatedPosts : [
                {
                    id: 0,
                    postAutherName: "Rahim Philip",
                    postTime: "5h ago",
                    postAuthorImage: "",
                    postThumbnail: "",
                    postDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tincidunt non augue ut commodo. Nullam id urna at quam dapibus efficitur. Nunc rhoncus risus quis consectetur sodales. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.",
                    postReaction: [
                        {
                            heart: 259,
                            massage: 259,
                            plus: 62,
                            share: 25
                        }
                    ]
                }
            ],
            eventMainDesc:[ 
                {
                    decs: '„Gucci“ – visame pasaulyje dominuojantis prekės ženklas, bet dar negirdėta jo šeimos istorija, kurioje slypi melas, išdavystė, kerštas ir žmogžudystė. Buvusi Maurizio Gucci žmona, Patrizia Reggiani, buvo apkaltinta savo vyro žmogžudystės užsaky mu po to, kai buvo palikta dėl Lily Luis',
                    eventMainDescImages : [ eventMainDescUserImageFour,eventMainDescUserImageFive ]
                },
            ]
        },
    ]
}